import { IDirectDiscounts } from '../data/entities/direct-discounts';
import { IConfiguredHttp } from './http';

export interface IMarketingPreferencesApi {
	sendPropertyPromotionEvent: (event: PromotionsEventType, propertyIds: string[]) => Promise<any>;
	getDirectDiscounts: (propertyId: string) => Promise<IDirectDiscounts[]>;
}

export type PromotionsEventType = 'bcom-preferred-partner-opt-in' | 'bcom-preferred-partner-opt-out' | 'bcom-genius-opt-in' | 'bcom-genius-opt-out';

const promotionsEventFormatter = (event: PromotionsEventType, payload: any): { uri: string | null, payload: any } => {
	if (event === 'bcom-preferred-partner-opt-in') {
		return { uri: 'promotion/BCOM_PREFERRED_PARTNER/channel/booking.com/manual-opt-in', payload: { property_ids: payload } };
	} else if (event === 'bcom-preferred-partner-opt-out') {
		return { uri: 'promotion/BCOM_PREFERRED_PARTNER/channel/booking.com/manual-opt-out', payload: { property_ids: payload } };
	} else if (event === 'bcom-genius-opt-in') {
		return { uri: 'promotion/BCOM_GENIUS_L1/channel/booking.com/manual-opt-in', payload: { property_ids: payload } };
	} else if (event === 'bcom-genius-opt-out') {
		return { uri: 'promotion/BCOM_GENIUS_L1/channel/booking.com/manual-opt-out', payload: { property_ids: payload } };
	}
	return { uri: null, payload: { payload } };
};

const marketingPreferencesApiFactory = (http: IConfiguredHttp, prefix = ''): IMarketingPreferencesApi => ({
	async sendPropertyPromotionEvent(event, propertyIds) {
		const { uri, payload } = promotionsEventFormatter(event, propertyIds);
		if (!uri) {
			throw new Error(`Invalid event ${event}`);
		}
		return http.post(`${prefix}/${uri}`, payload);
	},
	async getDirectDiscounts(propertyId) {
		return http.get(`${prefix}/property/${propertyId}/direct-discounts`);
	},
});

export default marketingPreferencesApiFactory;
